import "./topDisplayLeft.css";
import { useTranslation } from "react-i18next";

const TopDisplayLeft = ({ loginLink }) => {
    const { t } = useTranslation("homePage");

    return (
        <>
            <div className="displayComponentHomePageLeftContainerTop">
                <div className="displayComponentHomePageLeftimageContainer">
                    <img
                        src="logo.svg"
                        className="displayComponentHomePageLogo"
                        alt="logo"
                    />
                </div>

                <div className="displayComponentHomePageBadningContainer">
                    <span className="displayComponentHomePageBranding1">
                        STREAM{" "}
                        <span className="displayComponentHomePageBranding2">
                            MEMES
                        </span>
                    </span>
                </div>

                <div className="displayComponentHomePageTextTopContainer">
                    <p className="displayComponentHomePageTextTop">
                        {t("topDisplayLeftBelowBranding")}
                    </p>
                </div>

                <div className="displayComponentHomePageButtonContainerTop">
                    <a
                        className="displayComponentHomePageButtonLogin"
                        href={loginLink}
                    >
                        <button className="displayComponentHomePageButton">
                            {t("streamerLoginButton")}
                        </button>
                    </a>

                    <a
                        href="https://discord.gg/dCg5A789"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button className="displayComponentHomePageButtonIcon">
                            <img
                                src="discord.svg"
                                className="displayComponentHomePageIconDisplay"
                                alt="discord"
                            />
                        </button>
                    </a>

                    <a
                        href="https://twitter.com/StreamMemesApp"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button className="displayComponentHomePageButtonIcon">
                            <img
                                src="twitter.svg"
                                className="displayComponentHomePageIconDisplay"
                                alt="twitter"
                            />
                        </button>
                    </a>
                </div>
            </div>
        </>
    );
};

export default TopDisplayLeft;
